var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "w-screen h-screen lg:p-10 bg-pure-white overflow-hidden" },
    [
      _c("div", { staticClass: "bl-auth-background px-4 lg:p-0" }, [
        _c(
          "div",
          { staticClass: "bl-auth-card rounded-3xl bg-pure-white p-6 lg:p-12" },
          [
            !_vm.hasAnotherDeviceSignedIn
              ? _c(
                  "form",
                  {
                    staticClass: "lg:w-128",
                    on: {
                      submit: function($event) {
                        $event.preventDefault()
                        return _vm.onSignin($event)
                      }
                    }
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "text-center space-y-3 mb-6" },
                      [
                        _c(
                          "div",
                          {
                            staticClass:
                              "font-logo text-light-purple font-bold text-4xl"
                          },
                          [_vm._v("\n            Blüm\n          ")]
                        ),
                        _vm._v(" "),
                        _c("BlTextBody2", {
                          attrs: {
                            text:
                              "Streamline your ABA therapy data collection process and make your sessions more effective."
                          }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("BlInputText", {
                      staticClass: "mb-4",
                      attrs: { input: _vm.emailInput },
                      on: { changed: _vm.inputHandler }
                    }),
                    _vm._v(" "),
                    _c("BlInputText", {
                      staticClass: "mb-4",
                      attrs: { input: _vm.passwordInput },
                      on: { changed: _vm.inputHandler }
                    }),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "flex items-center justify-between mb-4" },
                      [
                        _c(
                          "div",
                          {
                            staticClass:
                              "flex items-center gap-3 cursor-pointer",
                            on: { click: _vm.onChangeRememberMe }
                          },
                          [
                            _c("BlInputCheck", {
                              attrs: { checked: _vm.rememberMe },
                              on: { changed: _vm.onChangeRememberMe }
                            }),
                            _vm._v(" "),
                            _c("BlTextBody2", {
                              attrs: { text: "Remember me" }
                            })
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c("BlInputButton", {
                          attrs: { type: "plain", label: "Forgot Password?" },
                          on: { clicked: _vm.goForgotPassword }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("BlInputButton", {
                      staticClass: "w-full",
                      attrs: {
                        buttonType: "submit",
                        label: "Sign In",
                        loading: _vm.submitLoading
                      }
                    })
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.hasAnotherDeviceSignedIn
              ? _c(
                  "div",
                  { staticClass: "lg:w-128 flex flex-col gap-4" },
                  [
                    _c(
                      "div",
                      { staticClass: "flex flex-col gap-3" },
                      [
                        _c(
                          "div",
                          {
                            staticClass:
                              "font-logo text-light-purple font-bold text-2xl"
                          },
                          [_vm._v("\n            Blüm\n          ")]
                        ),
                        _vm._v(" "),
                        _c("BlTextTitle4", {
                          staticClass: "text-light-purple",
                          attrs: {
                            text: "Sign out from another device to access Blüm"
                          }
                        }),
                        _vm._v(" "),
                        _c(
                          "div",
                          [
                            _c("BlTextBody2", {
                              attrs: {
                                text:
                                  "You've reached the maximum number of devices allowed for"
                              }
                            }),
                            _vm._v(" "),
                            _c("BlTextBody2", {
                              staticClass: "font-bold",
                              attrs: { text: _vm.user.email + "." }
                            }),
                            _vm._v(" "),
                            _c("BlTextBody2", {
                              attrs: {
                                text:
                                  "To sign in here, please choose a device to log out from. Once signed out, you'll be able to continue on this device."
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _vm._l(_vm.activeDevices, function(device) {
                      return _c(
                        "div",
                        {
                          key: device.id + device.updated_at,
                          staticClass:
                            "py-3 flex items-center justify-between border-b border-slate-300"
                        },
                        [
                          _c(
                            "div",
                            { staticClass: "flex items-center gap-3 truncate" },
                            [
                              device.status === "active"
                                ? _c("BlIcon", {
                                    staticClass: "h-6 w-6",
                                    attrs: {
                                      icon: "check-circle",
                                      color: "grass-6"
                                    }
                                  })
                                : _vm._e(),
                              _vm._v(" "),
                              device.status === "inactive"
                                ? _c("BlIcon", {
                                    staticClass: "h-6 w-6",
                                    attrs: {
                                      icon: "check-circle",
                                      color: "slate-6"
                                    }
                                  })
                                : _vm._e(),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "flex flex-col gap-1 truncate" },
                                [
                                  device.device_details
                                    ? _c(
                                        "div",
                                        { staticClass: "truncate" },
                                        [
                                          device.device_details.os_name
                                            ? _c("BlTextSubtitle3", {
                                                attrs: {
                                                  text:
                                                    device.device_details
                                                      .os_name
                                                }
                                              })
                                            : _vm._e(),
                                          _vm._v(" "),
                                          device.device_details.os_version
                                            ? _c("BlTextSubtitle3", {
                                                attrs: {
                                                  text:
                                                    device.device_details
                                                      .os_version
                                                }
                                              })
                                            : _vm._e(),
                                          _vm._v(" "),
                                          device.device_details.device_name
                                            ? _c("BlTextSubtitle3", {
                                                attrs: {
                                                  text:
                                                    device.device_details
                                                      .device_name
                                                }
                                              })
                                            : _vm._e()
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    [
                                      _c("BlTextBody2", {
                                        attrs: { text: "Last accessed:" }
                                      }),
                                      _vm._v(" "),
                                      _c("BlTextBody2", {
                                        attrs: {
                                          text: _vm.displayDate({
                                            date: device.last_accessed_at,
                                            format: "DD MMM YYYY"
                                          })
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ]
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          device.status === "active"
                            ? _c("BlInputButton", {
                                attrs: {
                                  label: "Sign out",
                                  type: "outlined",
                                  dense: ""
                                },
                                on: {
                                  clicked: function($event) {
                                    return _vm.onSignoutDevice(device)
                                  }
                                }
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          device.status === "inactive"
                            ? _c("BlInputButton", {
                                attrs: {
                                  label: "Signed out",
                                  type: "outlined",
                                  dense: "",
                                  disabled: ""
                                }
                              })
                            : _vm._e()
                        ],
                        1
                      )
                    }),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "grid grid-cols-2 gap-4" },
                      [
                        _c("BlInputButton", {
                          attrs: { label: "Back to sign-in", type: "outlined" },
                          on: {
                            clicked: function($event) {
                              _vm.hasAnotherDeviceSignedIn = false
                            }
                          }
                        }),
                        _vm._v(" "),
                        _c("BlInputButton", {
                          attrs: {
                            label: "Continue using this device",
                            disabled:
                              _vm.activeDevices.filter(function(i) {
                                return i.status === "active"
                              }).length > 1,
                            loading: _vm.submitLoading
                          },
                          on: { clicked: _vm.onSignin }
                        })
                      ],
                      1
                    )
                  ],
                  2
                )
              : _vm._e()
          ]
        )
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-417e8ba9", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-417e8ba9","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/auth/Signin.vue
// module id = null
// module chunks = 